import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className="relative bg-black text-white" data-id="element-106">
      {/* Sticky Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-300 ${isScrolled ? 'bg-black/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'}`} data-id="element-107">
        <div className="max-w-[1200px] mx-auto px-4 lg:px-8" data-id="element-108">
          <div className="flex h-16 lg:h-20 items-center justify-between" data-id="element-109">
            {/* Logo */}
            <div className="flex items-center gap-2 flex-shrink-0" data-id="element-110">
              <img src="https://cdn.magicpatterns.com/uploads/hrXX85rhn4YR9sbdgFXsGs/beclinical.svg_(1).png" alt="Be Clinical" className="h-10 w-auto" data-id="element-111" />
            </div>

            {/* Desktop Nav */}
            <div className="hidden lg:flex items-center gap-6 xl:gap-8" data-id="element-112">
              <a href="#about" className="text-[13px] uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors relative after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-[1px] after:bg-[#FF1493] after:transition-all hover:after:w-full" data-id="element-113">
                About Us
              </a>
              <a href="#treatments" className="text-[13px] uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors relative after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-[1px] after:bg-[#FF1493] after:transition-all hover:after:w-full" data-id="element-114">
                Treatments
              </a>
              <a href="#financing" className="text-[13px] uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors relative after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-[1px] after:bg-[#FF1493] after:transition-all hover:after:w-full" data-id="element-115">
                Financing
              </a>
              <a href="#testimonials" className="text-[13px] uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors relative after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-[1px] after:bg-[#FF1493] after:transition-all hover:after:w-full" data-id="element-116">
                Testimonials
              </a>
              <a href="#specials" className="text-[13px] uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors relative after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-[1px] after:bg-[#FF1493] after:transition-all hover:after:w-full" data-id="element-117">
                Specials
              </a>
              <a href="#membership" className="text-[13px] uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors relative after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-[1px] after:bg-[#FF1493] after:transition-all hover:after:w-full" data-id="element-118">
                Membership
              </a>
              <a href="#blog" className="text-[13px] uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors relative after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-[1px] after:bg-[#FF1493] after:transition-all hover:after:w-full" data-id="element-119">
                Blog
              </a>
              <Button variant="primary" size="sm" data-id="element-120">
                Book Consult
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <button className="lg:hidden p-2 text-white" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-121">
              {isMenuOpen ? <XIcon size={24} data-id="element-122" /> : <MenuIcon size={24} data-id="element-123" />}
            </button>
          </div>
        </div>

        {/* Mobile Full-Screen Overlay */}
        {isMenuOpen && <div className="lg:hidden fixed inset-0 z-50 bg-[#111111] overflow-y-auto flex flex-col items-center justify-center gap-8 p-8 pt-24" data-id="element-124">
            {/* Close Button */}
            <button onClick={() => setIsMenuOpen(false)} className="absolute top-6 right-6 p-2 text-white hover:text-[#FF1493] transition-colors" aria-label="Close menu" data-id="element-125">
              <XIcon size={28} data-id="element-126" />
            </button>

            <a href="#about" onClick={() => setIsMenuOpen(false)} className="text-lg uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors font-heading" data-id="element-127">
              About Us
            </a>
            <a href="#treatments" onClick={() => setIsMenuOpen(false)} className="text-lg uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors font-heading" data-id="element-128">
              Treatments
            </a>
            <a href="#financing" onClick={() => setIsMenuOpen(false)} className="text-lg uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors font-heading" data-id="element-129">
              Financing
            </a>
            <a href="#testimonials" onClick={() => setIsMenuOpen(false)} className="text-lg uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors font-heading" data-id="element-130">
              Testimonials
            </a>
            <a href="#specials" onClick={() => setIsMenuOpen(false)} className="text-lg uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors font-heading" data-id="element-131">
              Specials
            </a>
            <a href="#membership" onClick={() => setIsMenuOpen(false)} className="text-lg uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors font-heading" data-id="element-132">
              Membership
            </a>
            <a href="#blog" onClick={() => setIsMenuOpen(false)} className="text-lg uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors font-heading" data-id="element-133">
              Blog
            </a>
            <Button variant="primary" size="lg" className="w-full max-w-xs mt-4" onClick={() => setIsMenuOpen(false)} data-id="element-134">
              Book Consult
            </Button>
          </div>}
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center overflow-hidden" data-id="element-135">
        {/* Background Image */}
        <div className="absolute inset-0" data-id="element-136">
          <img src="https://cdn.magicpatterns.com/uploads/cSJVnYp3pfX4aP7qKbPk6P/Be_Clinical_Hero_Image_Text_(2).png" alt="Woman receiving beauty treatment with glowing skin, hands in black medical gloves framing her face" className="h-full w-full object-cover object-center" data-id="element-137" />
          {/* Gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-black via-black/50 to-transparent" data-id="element-138"></div>
          <div className="absolute inset-0 bg-black/30 lg:bg-transparent" data-id="element-139"></div>
        </div>

        {/* Decorative Script Words - hidden on mobile */}
        <div className="absolute inset-0 hidden md:block pointer-events-none z-10" data-id="element-140"></div>

        {/* Hero Content */}
        <div className="relative z-20 w-full max-w-[1200px] mx-auto px-6 lg:px-8 pt-28 pb-16 lg:pt-0 lg:pb-0" data-id="element-141">
          <div className="max-w-2xl" data-id="element-142">
            {/* Main Headline - BE EXCELLENT */}
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-[80px] uppercase tracking-tight mb-6 text-center font-[500] font-[Poppins,_sans-serif] text-[#FF1493]" data-id="element-143">
              BE EXCELLENT
            </h1>

            {/* Diamond Shape */}
            <div className="flex justify-center mb-8 items-center" data-id="element-144">
              <img src="https://cdn.magicpatterns.com/uploads/uu9vckamxznJfhWXHg2VLM/Vector_12_(1).png" alt="" className="h-auto" style={{
              width: '18px'
            }} data-id="element-145" />
            </div>

            {/* Subheadline */}
            <h2 className="font-serif italic text-2xl sm:text-3xl md:text-4xl lg:text-[42px] text-white leading-[1.2] mb-10 text-center" data-id="element-146">
              The Art of Aesthetics.
              <br data-id="element-147" />
              The Science of You.
            </h2>

            {/* CTA */}
            <div className="flex justify-center items-center" data-id="element-148">
              <Button variant="primary" size="lg" className="w-full sm:w-auto min-h-[52px] px-10 text-sm tracking-widest" data-id="element-149">
                SCHEDULE CONSULTATION
              </Button>
            </div>
          </div>
        </div>
      </section>
    </header>;
}